export default __webpack_public_path__ + "static/media/myrecordings.9ddcaf82.svg";